<template>
  <div class="p-6 flex flex-col items-center justify-center min-h-screen">
    <h2 class="text-2xl font-semibold mb-4 text-center">Unsupported Content Type</h2>
    <p class="text-gray-600 mb-6 text-center max-w-md">
      We're sorry, but we don't have a specific view for this content type yet. We're working on
      expanding our supported types.
    </p>
    <AppLink
      to="/"
      class="px-4 py-2 bg-black text-white rounded-md hover:bg-black/90 transition-colors duration-300"
    >
      Return to Home
    </AppLink>
  </div>
</template>

<script setup lang="ts">
// No additional setup required for this component
</script>
